import { TemplateData } from './htmlTemplates';

export const geometricBoldTemplate = {
  id: 'geometric-bold',
  name: '几何大胆',
  description: '几何图形设计，适合创意和设计内容',
  category: 'creative',
  generate: (data: TemplateData) => `
    <!DOCTYPE html>
    <html lang="zh-CN">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Cover</title>
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .cover {
          width: 400px;
          height: 600px;
          background: #ffffff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 40px;
          font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
          position: relative;
          overflow: hidden;
        }

        .geometric-bg {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: 
            linear-gradient(45deg, ${data.theme.primaryColor}20 25%, transparent 25%),
            linear-gradient(-45deg, ${data.theme.accentColor}20 25%, transparent 25%),
            linear-gradient(45deg, transparent 75%, ${data.theme.primaryColor}15 75%),
            linear-gradient(-45deg, transparent 75%, ${data.theme.accentColor}15 75%);
          background-size: 60px 60px;
          background-position: 0 0, 0 30px, 30px -30px, -30px 0px;
          opacity: 0.3;
        }

        .brand-geo {
          position: absolute;
          top: 30px;
          right: 30px;
          font-size: 20px;
          color: ${data.theme.primaryColor};
          font-weight: bold;
          z-index: 3;
        }

        .title {
          font-size: 44px;
          font-weight: 900;
          color: #1a1a1a;
          text-align: center;
          line-height: 1.1;
          margin-bottom: 30px;
          letter-spacing: -1px;
          position: relative;
          z-index: 2;
        }

        .title-geometric {
          background: ${data.theme.primaryColor};
          color: white;
          padding: 5px 10px;
          margin: 0 3px;
          transform: skew(-10deg);
          display: inline-block;
          box-shadow: 4px 4px 0px ${data.theme.accentColor};
        }

        .subtitle {
          font-size: 18px;
          color: #333333;
          text-align: center;
          line-height: 1.4;
          font-weight: 500;
          position: relative;
          z-index: 2;
          max-width: 300px;
        }

        .geo-highlight {
          background: ${data.theme.accentColor};
          color: white;
          padding: 2px 8px;
          margin: 0 2px;
          transform: skew(-5deg);
          display: inline-block;
          font-weight: 700;
          box-shadow: 2px 2px 0px ${data.theme.primaryColor};
        }

        .triangle-left {
          position: absolute;
          top: 100px;
          left: 30px;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 0 0 60px 60px;
          border-color: transparent transparent ${data.theme.primaryColor}40 transparent;
          z-index: 1;
        }

        .triangle-right {
          position: absolute;
          bottom: 100px;
          right: 30px;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 60px 60px 0 0;
          border-color: ${data.theme.accentColor}40 transparent transparent transparent;
          z-index: 1;
        }

        .circle-accent {
          position: absolute;
          top: 200px;
          left: 50px;
          width: 80px;
          height: 80px;
          border: 8px solid ${data.theme.primaryColor};
          border-radius: 50%;
          border-left-color: transparent;
          border-bottom-color: transparent;
          transform: rotate(45deg);
          z-index: 1;
        }

        .square-accent {
          position: absolute;
          bottom: 200px;
          right: 50px;
          width: 60px;
          height: 60px;
          background: ${data.theme.accentColor}60;
          transform: rotate(15deg);
          z-index: 1;
        }

        .square-accent::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(45deg);
          width: 30px;
          height: 30px;
          background: ${data.theme.primaryColor};
        }

        .bottom-shapes {
          position: absolute;
          bottom: 50px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 15px;
          z-index: 2;
        }

        .shape-dot {
          width: 12px;
          height: 12px;
          background: ${data.theme.primaryColor};
          border-radius: 50%;
        }

        .shape-square {
          width: 12px;
          height: 12px;
          background: ${data.theme.accentColor};
        }

        .shape-triangle {
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 0 6px 12px 6px;
          border-color: transparent transparent ${data.theme.primaryColor} transparent;
        }
      </style>
    </head>
    <body>
      <div class="cover">
        <div class="geometric-bg"></div>
        <div class="brand-geo">${data.theme.logo}</div>
        
        <div class="triangle-left"></div>
        <div class="triangle-right"></div>
        <div class="circle-accent"></div>
        <div class="square-accent"></div>
        
        <h1 class="title">
          ${data.title.split(' ').map((word, i) => 
            i % 2 === 0 ? `<span class="title-geometric">${word}</span>` : word
          ).join(' ')}
        </h1>
        <p class="subtitle">${data.subtitle.replace(/([^\s]{2,5})/g, '<span class="geo-highlight">$1</span>')}</p>
        
        <div class="bottom-shapes">
          <div class="shape-dot"></div>
          <div class="shape-square"></div>
          <div class="shape-triangle"></div>
          <div class="shape-dot"></div>
          <div class="shape-square"></div>
        </div>
      </div>
    </body>
    </html>
  `
};
